<script lang="ts" setup>
import Header from '~/components/layouts/Header.vue'
import Footer from '~/components/layouts/Footer.vue'
import BottomBar from '~/components/custom-ui/BottomBar.vue'

const route = useRoute()

// Проверяем, что мы не на странице create-account, когда не должны быть там
const isCreateAccountPage = computed(() => {
    return route.name === 'create_account' || route.path.includes('create-account');
});
</script>

<template>
    <div class="default_layout min-h-screen flex flex-col justify-between">
         <div class="main_row">
            <Header />
            <NuxtPage :key="route.fullPath" />
        </div>
        <Footer />
        <BottomBar />
    </div>
</template>